import React, { useContext, useEffect, useState } from "react";
import { estructuraOrdenTrabajo } from "../../utils/estructuras";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";

// Alertas
import Swal from 'sweetalert2'

import TareaContext from '../../context/tareaContext/tareaContex';
import authContext from '../../context/authentication/authContex';

import {addToDate, getDifferenceInDays} from '../../utils/funciones'


const ModalFormDragAndDropCtrls = ({procedimiento, usuario, minimizar, guardarRequerimientosFromCtrlsFallidos, getMantenimientosProgramados}) =>{

    const [ctrlsFallidos,setCtrlsFallidos] = useState([]);
    const [ordenesTrabajo,setOrdenesTrabajo] = useState([{...estructuraOrdenTrabajo, label:"Agregar Orden de Trabajo", controles:[]}]);
    const [draggedItem, setDraggedItem] = useState({});
    const [controlesIsHovered,setControlesIsHovered] = useState(false);
    const [creatingOTs, setCreatingOTs] = useState(false);
    const {tareaIDLista} = useContext(TareaContext);
    const {globalSettings} = useContext(authContext);
    const allowPartial = globalSettings?.allowPartialFailedCtrlsODT === true;

    const handleOnDragStart = (c, i = undefined) =>{
        setDraggedItem({...c, otFrom:(i != undefined) ? i : undefined});
    }

    const handleOnDrop = (i, c, from="ctrlsFallidos") =>{
        //Accede aca cuando proviene de ctrlsFallidos dirigida a una Orden Trabajo.
        if(from=="ctrlsFallidos" && Object.keys(draggedItem).length > 0){
            let ctrsFallidosNew = ctrlsFallidos.filter(c => c.codigo != draggedItem.codigo);
            setCtrlsFallidos(ctrsFallidosNew);

            let ordenesTrabajoNew = ordenesTrabajo.slice();
            (ordenesTrabajoNew[i].controles.length == 0 && ordenesTrabajoNew[i].label == "Agregar Orden de Trabajo") && ordenesTrabajoNew.push({...estructuraOrdenTrabajo, label:`Agregar Orden de Trabajo`, controles:[]});

            //Si no existe un control igual en la misma OT en la cual se esta dropeando, este control es insertado en la OT.
            if(!(ordenesTrabajoNew[i].controles.some(c => c.codigo == draggedItem.codigo))){
                ordenesTrabajoNew[i].controles.push(draggedItem);
                ordenesTrabajoNew[i].isHovered = false;
            }

            //Si proviene de una OT y no se esta dropeando en la misma OT, este control es eliminado de la OT origen.
            if(draggedItem.otFrom != undefined && i != draggedItem.otFrom) ordenesTrabajoNew[draggedItem.otFrom].controles = ordenesTrabajoNew[draggedItem.otFrom].controles.filter(c => c.codigo != draggedItem.codigo);

            ordenesTrabajoNew = ordenesTrabajoNew.filter(c => c.controles.length > 0 || c.label == "Agregar Orden de Trabajo");
            
            ordenesTrabajoNew.map((c,i) => c.label = c.controles.length > 0 ? `Orden de Trabajo ${i+1}` : c.label);
            setOrdenesTrabajo(ordenesTrabajoNew);
            setDraggedItem({});
        }else if(Object.keys(draggedItem).length > 0){
            if(draggedItem.otFrom != undefined){
                let ordenesTrabajoNew = ordenesTrabajo.slice();
                ordenesTrabajoNew[draggedItem.otFrom].controles = ordenesTrabajoNew[draggedItem.otFrom].controles.filter(c => c.codigo != draggedItem.codigo);
                
                if(ordenesTrabajoNew[draggedItem.otFrom].controles.length == 0) ordenesTrabajoNew = ordenesTrabajoNew.filter((c,index) => index != draggedItem.otFrom);

                ordenesTrabajoNew.map((c,i) => c.label = c.controles.length > 0 ? `Orden de Trabajo ${i+1}` : c.label);
                ordenesTrabajoNew = ordenesTrabajoNew.filter(c => c.controles.length > 0 || c.label == "Agregar Orden de Trabajo");
                setOrdenesTrabajo(ordenesTrabajoNew);
                let ctrlsFallidosNew = ctrlsFallidos.slice();
                let draggedItemNew = {otFrom: "", ...draggedItem};
                ctrlsFallidosNew.push((draggedItem.otFrom != undefined) ? {otFrom: "",...draggedItem} : {...draggedItem});
                setCtrlsFallidos(ctrlsFallidosNew);
                setControlesIsHovered(false);
            }
        }
    }

    const handleDragEnterLeaveControlesDiv = (boolean) =>{
        setControlesIsHovered(boolean);
    }
    const handleDragEnterLeaveOTDiv = (otIndex,boolean) =>{
        let ordenesTrabajoNew = ordenesTrabajo.slice();
        ordenesTrabajoNew[otIndex].isHovered = boolean;
        setOrdenesTrabajo(ordenesTrabajoNew);
    }
  
    const handleSaveOTs = async() =>{
        if(!creatingOTs){
            if(ctrlsFallidos.length > 0 && allowPartial){
                const confirmResult = await Swal.fire({
                    title: '¿Está seguro?',
                    html: 'Quedan controles fallidos sin asignar a ninguna Orden de Trabajo.<br/>Estos controles fallidos se perderan definitavemente, no pudiendo crear ordenes de trabajo sobre ellos luego.<br/>¿Desea continuar de todas formas?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, continuar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#3d4d87',
                    cancelButtonColor: '#ff0000',
                });
                if(!confirmResult.isConfirmed) return;
            }
            Swal.fire({
                title:"Generando ODTs...",
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            setCreatingOTs(true);
            let newFec = new Date();
            let tareaGenerica = tareaIDLista.find(t => t.codTarea == 'TGENERICASYSTEM');

            //Cada ODT adicional a la primera necesita su propio proc, creado a partir de este template.
            let procTemplate = {
                codActivo: procedimiento.codActivo,
                codProc: procedimiento.codProc,
                uniMed: 'DAYS',
                valorLecturaUltima: getDifferenceInDays(new Date(procedimiento.activoFecIng), new Date()),
                valorLecturaVencimiento: getDifferenceInDays(new Date(procedimiento.activoFecIng), addToDate(new Date(),365,'day','add')),
                valorLecturaAlerta: getDifferenceInDays(new Date(procedimiento.activoFecIng), new Date()),
                valorLecturaCompletado: 0,
                fechaVencimiento: addToDate(new Date(),365,'day','add').toISOString().substring(0,16),
                fechaCompletado: '',
                CodForOT:"",
                NroForOT:'0',
                codChecklistReg: procedimiento.codChecklistReg, 
                nroChecklistReg: procedimiento.nroChecklistReg,
                tipoAlerta:'PorVENC',
                state:'PEND',
                fecMod: newFec,
                fecAlt: newFec,
                activoID: procedimiento.activoID,
                originado: "CHECKLIST",
                procedimientoID: procedimiento.procedimientoID,
                checklistRegID: procedimiento.checklistRegID
            };

            let ordenesToUpload = ordenesTrabajo.filter(c => c.controles.length > 0).map(ot => ({
                title:`Orden de Trabajo s/${procedimiento.codProc} - ${procedimiento.nameActivo}`, 
                observ:`Orden de Trabajo sobre ${procedimiento.codProc} (${procedimiento.codChecklistReg} - ${procedimiento.nroChecklistReg}) asociado al activo ${procedimiento.codActivo} (${procedimiento.nameActivo})`, 
                tareas: [{codTarea: tareaGenerica.codTarea, id: tareaGenerica._id, done: false, descrp: tareaGenerica.descrp}], 
                imputaciones:[],
                controles: ot.controles,
                activo:{id: procedimiento.activoID, label: procedimiento.nameActivo, value: procedimiento.codActivo}
            }));

            const resp = await guardarRequerimientosFromCtrlsFallidos(procedimiento, ordenesToUpload, procTemplate, usuario);

            if(!resp.status){
                setCreatingOTs(false);
                Swal.fire({
                    title: `Algo no funciono segun lo esperado!`,
                    icon: 'error',
                    text: resp.msg,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                return;
            }

            await getMantenimientosProgramados();
            Swal.fire({
                title: `Órdenes de Trabajo creadas con Éxito!`,
                icon: 'success',
                text: (resp.data.length == 1) ? `La Orden de Trabajo ${resp.data[0].tDocNroFor} fue creada exitosamente` : `Las Ordenes de Trabajo ${resp.data.map(ot => ot.tDocNroFor).join(", ")} fueron creadas exitosamente`,
                showConfirmButton: true,
                allowEnterKey: true
            });
            minimizar();
        }
    }

    useEffect(()=>{
        let ctrlsFallidosCopy = procedimiento.controlesFallidos.slice().filter(c => !c.noDisparaProc);
        setCtrlsFallidos(ctrlsFallidosCopy);
    },[procedimiento]);

    return <div className="modalFormDiv modalFormDragAndDropCtrls">
         <button className="minimizarBtn" onClick={minimizar}>X</button>
         <div className="headerModalForm">Distribuir para creación de Órdenes de Trabajo</div>
         <div className="bodyModalForm">
            <div className={`ctrlFallidosDiv ${controlesIsHovered ? 'isHovered' : ''}`} onDragEnter={()=>handleDragEnterLeaveControlesDiv(true)} onDragLeave={()=>handleDragEnterLeaveControlesDiv(false)} onDragOver={(e) => e.preventDefault()} onDrop={(c)=>handleOnDrop(0, c, "ots")}>
                {ctrlsFallidos.map((c,i) => <div className="ctrlFallidoDiv" key={i} draggable  onDragStart={()=>handleOnDragStart(c)}>
                    <h5>{`${c.codigo} - ${c.descrp}`}</h5>
                    <h6>{c.textAdic}</h6>
                </div>)}
            </div>
            <div className="ordenesTrabajoDiv">
                {ordenesTrabajo.map((ot,iOt) => <div key={iOt} className={`ordenTrabajoDiv`}>
                    <label className="otLabel">{ot.label}</label>
                    
                    <div className={`otBodyDiv ${ot.isHovered ? 'isHovered' : ''}`} onDragEnter={()=>handleDragEnterLeaveOTDiv(iOt,true)} onDragLeave={()=>handleDragEnterLeaveOTDiv(iOt,false)}  onDragOver={(e) => e.preventDefault()} onDrop={(c)=>handleOnDrop(iOt, c)}>
                        {ot.controles.map((c,iC) => <div className="controlOTDiv" key={iC} draggable onDragStart={()=>handleOnDragStart(c, iOt)}>
                            <h6>{c.codigo} - {c.descrp}</h6>
                            <label>{c.textAdic}</label>
                        </div>)}
                    </div>

                </div>)}
            </div>
         </div>
        <button className="btn" disabled={(ctrlsFallidos.length > 0 && !allowPartial) || creatingOTs || ordenesTrabajo.every(ot => ot.controles.length === 0)} onClick={handleSaveOTs}>Crear Órdenes de Trabajo</button>
    </div>

}

export default ModalFormDragAndDropCtrls;